import React from "react";
import { useCareManagementQuery } from "../../../hooks/queries/useCareManagementQuery";
import { useAppSelector } from "../../../store/hooks";
import CairePollingShell from "../CairePollingShell";
import DcBarriersPanel from "./DcBarriersPanel";
import type { DcBarriersBySetting, DcBarriersRequirement } from "./types";

const DcBarriers: React.FC = () => {
  const mrn = useAppSelector((state) => state.fhir.mrn) ?? "";
  const providerNpi = useAppSelector((state) => state.provider.providerNPI);
  const { data, isLoading, isFetching, isError } = useCareManagementQuery(
    mrn,
    providerNpi,
    { polling: true }
  );

  if (isLoading)
    return (
      <p className="p-4 text-sm text-gray-500">
        Loading care management data...
      </p>
    );
  if (isError)
    return (
      <p className="p-4 text-sm text-red-600">
        Unable to load care management data.
      </p>
    );
  if (!data?.review)
    return (
      <p className="p-4 text-sm text-gray-500">
        No care management query is assigned for this patient.
      </p>
    );

  const overrides = data.case?.dischargeReadinessOverrides ?? {};
  const dischargeReadiness = (data.review.dischargeReadiness ?? []).map(
    (setting: DcBarriersBySetting) => ({
      ...setting,
      Requirements: (setting.Requirements ?? []).map(
        (requirement: DcBarriersRequirement) => ({
          ...requirement,
          Status:
            overrides[`${setting.Setting}::${requirement.SignalName}`]
              ?.toStatus ?? requirement.Status,
        }),
      ),
    }),
  );

  return (
    <CairePollingShell refreshing={isFetching && !isLoading}>
      <DcBarriersPanel
        data={dischargeReadiness}
        finalizedDisposition={
          data.case?.pacFinalization?.dischargeDisposition ??
          data.review.predictedDisposition ??
          null
        }
      />
    </CairePollingShell>
  );
};

export default DcBarriers;
export { DcBarriersPanel };
export type {
  DcBarriersBySetting,
  DcBarriersEvidence,
  DcBarriersPanelProps,
  DcBarriersRequirement,
  DcBarriersStatusFilter,
} from "./types";
